module.exports = __webpack_public_path__ + "img/des-1.3b5e6b62.jpg";